// Vite built-ins (development vs production mode)
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

// Supabase
const SUPABASE_PROJECT_ID="wvrwcjmsgvrtizmnmoze"
const SUPABASE_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind2cndjam1zZ3ZydGl6bW5tb3plIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE0NTE2MjEsImV4cCI6MjA3NzAyNzYyMX0.Nyb2NcP_E6DP7-Z5T-cHm8zTsFQT5Hp2rYHmz4yRfcE"
const SUPABASE_URL="https://wvrwcjmsgvrtizmnmoze.supabase.co"

// Facebook Pixel
const FACEBOOK_PIXEL_ID="1223091596532489"

// Firebase
const FIREBASE_API_KEY="AIzaSyDR0bTLDe3eGbq3DGkV3xTJD2_Z7GIyylM"
const FIREBASE_AUTH_DOMAIN="order-flow-a7f86.firebaseapp.com"
const FIREBASE_PROJECT_ID="order-flow-a7f86"
const FIREBASE_MESSAGING_SENDER_ID="849871665589"
const FIREBASE_APP_ID="1:849871665589:web:96a989db1899ce212541fc"
const FIREBASE_VAPID_KEY="BGFLsrehCWicc_5K5dBgVdneTG0KCKCWV2f6MdVy4blwewa7awXRvdzc_tzvg4BWpPPfydkLnm0AZUXEKAd75_k"


export {
  SUPABASE_PROJECT_ID,
  SUPABASE_KEY,
  SUPABASE_URL,
  FACEBOOK_PIXEL_ID,
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_VAPID_KEY,
};